import { useEffect } from 'react';

export function useResizeObserver(
  el: HTMLElement | null,
  onSize: (box: { width: number; height: number }) => void,
  throttleMs = 50
) {
  useEffect(() => {
    if (!el) return;

    let raf = 0;
    let last = 0;

    const fire = () => {
      const rect = el.getBoundingClientRect();
      onSize({ width: rect.width, height: rect.height });
    };

    const schedule = () => {
      const now = performance.now();
      if (now - last > throttleMs) {
        last = now;
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(fire);
      }
    };

    const ro = new ResizeObserver(schedule);
    ro.observe(el);

    // run once immediately
    fire();

    return () => {
      cancelAnimationFrame(raf);
      ro.disconnect();
    };
  }, [el, onSize, throttleMs]);
}
